import { hasActiveSession, isUserLoggedIn } from './session';
import { redirectToMainPage } from './routes';
import { restoreSession, terminateSession } from 'modules/access/reducers/session';
import { selectOrganizationById } from 'modules/organizations/reducers/organizations';

import { logError } from 'utils/log';

import type { GenericAnyCallback, GenericUnusedParams, Store } from 'types';

export const onEnterPublicPage = (store: Store, params: GenericUnusedParams, callback: GenericAnyCallback) => {
  if (!hasActiveSession()) {
    callback();
    return;
  }

  store.dispatch(restoreSession())
    .then(() => callback());
};

export const onEnterFrontPage = (store: Store, params: GenericUnusedParams, callback: GenericAnyCallback) => {
  if (!hasActiveSession()) {
    callback();
    return;
  }

  store.dispatch(restoreSession())
    .then(() => redirectToMainPage(store.getState()));
};

export const onEnterInternalPage = (store: Store, params: {
  id: number
}, callback: GenericAnyCallback) => {
  if (!hasActiveSession()) {
    store.dispatch(terminateSession())
      .then(() => callback());
    return;
  }

  const isOrganizationRoute = /^\/organizations\//.test(window.currentLocation.pathname);
  const state = store.getState();
  const { currentAccount } = state.account;
  const { newVersionReleased } = state.version;

  // if the state knows there is a new version available, then
  // we do a "hard" refresh on page change
  if (newVersionReleased) {
    window.location.reload();
    return;
  }


  if (!isUserLoggedIn(currentAccount)) { // on page reload if access token exists
    store.dispatch(restoreSession())
      .then(() => isOrganizationRoute && store.dispatch(selectOrganizationById(params.id)))
      .then(() => callback());
    return;
  }

  if (isOrganizationRoute) { // on changed location
    store.dispatch(selectOrganizationById(params.id));
  }

  callback();
};

export const getBrandIdsWithPermissionToAddBrandsToCrawler = (): Array<number> => {
  try {
    return JSON.parse(window.app.env.BRAND_IDS_WITH_PERMISSION_TO_ADD_BRANDS_TO_CRAWLER || '');
  } catch (error) {
    logError(error);

    return [];
  }
};
